import { createReduxAsyncThunk } from 'shared/utils';
import { brandsAPI } from 'entities/brands';

import { BRANDS_STATE } from '../../constants';

import { FavouriteBrand } from '../../types';

export const getFavouriteBrands = createReduxAsyncThunk<{ favouriteBrands: FavouriteBrand[] }>(
  `${BRANDS_STATE}/getFavouriteBrands`,
  async () => {
    const { data } = await brandsAPI.getFavouriteBrands();
    return data;
  }
);
